var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    attrs: {
      "id": "cards",
      "role": "list"
    }
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    var _step$answerImage, _step$answerImage$ima, _step$answerImage2, _step$answerImage2$im;
    return _c('flippable-card', {
      key: stepIndex,
      staticClass: "card",
      attrs: {
        "is-flipped": stepIndex < _vm.progress.stepIndex,
        "role": "listitem"
      }
    }, [_c('div', {
      staticClass: "back-side",
      attrs: {
        "slot": "card-back"
      },
      slot: "card-back"
    }, [_c('img', {
      attrs: {
        "alt": "The back side of a flippable card",
        "src": _vm.backOfCardPath
      }
    })]), _c('div', {
      staticClass: "front-side",
      attrs: {
        "slot": "card-front"
      },
      slot: "card-front"
    }, [_c('img', {
      attrs: {
        "alt": (_step$answerImage = step.answerImage) === null || _step$answerImage === void 0 ? void 0 : (_step$answerImage$ima = _step$answerImage.image) === null || _step$answerImage$ima === void 0 ? void 0 : _step$answerImage$ima.description,
        "src": (_step$answerImage2 = step.answerImage) === null || _step$answerImage2 === void 0 ? void 0 : (_step$answerImage2$im = _step$answerImage2.image) === null || _step$answerImage2$im === void 0 ? void 0 : _step$answerImage2$im.src
      }
    })])]);
  }), 1), _c('div', {
    attrs: {
      "id": "answers"
    }
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    return _c('div', {
      key: ("answer-" + stepIndex),
      staticClass: "answer"
    }, [_c('span', [_vm._v(_vm._s(_vm.getWordPart(step)))]), _c('blinking-cursor-text', {
      attrs: {
        "text": _vm.currentRound.letterCombo,
        "text-step": stepIndex
      }
    })], 1);
  }), 0)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }